import { themedUseStyletron } from '../../../theme/customTheme'

export function Fan3D({ running, height, width, duration }: any) {
    const [, theme] = themedUseStyletron();
    const strokeForeground = running ? theme.appColors.aggregate.on : "#C0C0C0";
    const fillBackground =  "#505050";

    return (
            <svg width={width || '100%'} height={height || '100%'} viewBox="0 0 120 120">
                <path id="rightPump_right" d="M66,90 L92,64 A40,40 0 0 0 100,40 L60,40" fill="#C0C0C0"></path>
                <path id="rightPump_airHoleRight" d="M 120,0 L100,20 L100,50 L120,30" fill="#707070"></path>
                <path id="rightPump_airHole" d="M 116,10 L104,22 L104,42 L116,30" fill={fillBackground}></path>
                <path id="rightPump_top" d="M 120,0 L60,0 A100,100 0 0 0 15,29 L100,20" fill="#C0C0C0"></path>
                <path id="rightPump_face" d="M 80,50 L80,60 A40,40 0 0 1 40,100 A40,40 0 0 1 0,60 A40,40 0 0 1 40,20 L100,20 L100,50" fill="#A0A0A0"></path>
                <svg id="rightPump_internals" x="10" y="30" width="60" height="60">
                    <clipPath  id="autoId_rightPumpclipPath16">
                        <circle cx="30" cy="30" r="30"></circle>
                    </clipPath>
                    <circle cx="30" cy="30" r="30" fill={fillBackground}></circle>
                    <g  style={{clipPath: 'url(#autoId_rightPumpclipPath16)' }}>
                        <g>
                            {running &&
                                <animateTransform attributeType="xml" attributeName="transform" type="translate" from="0 0" to="0 -20" dur={duration ?? '1s'} repeatCount="indefinite"></animateTransform>
                            }
                            <svg y="20" width="120" height="120"><path d="M 0,120 L120,0" strokeWidth="5" stroke={strokeForeground}></path></svg>
                            <svg y="0" width="120" height="120"><path d="M 0,120 L120,0" strokeWidth="5" stroke={strokeForeground}></path></svg>
                            <svg y="-20" width="120" height="120"><path d="M 0,120 L120,0" strokeWidth="5" stroke={strokeForeground}></path></svg>
                            <svg y="-40" width="120" height="120"><path d="M 0,120 L120,0" strokeWidth="5" stroke={strokeForeground}></path></svg>
                            <svg y="-60" width="120" height="120"><path d="M 0,120 L120,0" strokeWidth="5" stroke={strokeForeground}></path></svg>
                            <svg y="-80" width="120" height="120"><path d="M 0,120 L120,0" strokeWidth="5" stroke={strokeForeground}></path></svg>
                            <svg y="-100" width="120" height="120"><path d="M 0,120 L120,0" strokeWidth="5" stroke={strokeForeground}></path></svg>
                        </g>
                    </g>
                    <circle cx="40" cy="10" r="30" fill="#404040"  style={{clipPath: 'url(#autoId_rightPumpclipPath16)' }} ></circle>
                    <circle cx="40" cy="10" r="10" fill="#707070"  style={{clipPath: 'url(#autoId_rightPumpclipPath16)' }}></circle>
                </svg>

            </svg>
    );
}
